import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';

declare const $: any;

@Component({
  selector: 'app-paymentiframe',
  templateUrl: './paymentiframe.component.html',
  styleUrls: ['./paymentiframe.component.css']
})
export class PaymentiframeComponent {

    @ViewChild('paymentIframe') paymentIframe!: ElementRef<HTMLIFrameElement>;
     @Input() loadingPayment = false;
  

  openPaymentWindow(url: any) {    
    
    this.loadingPayment = true;
    const iframe = this.paymentIframe.nativeElement;

    const onLoad = () => {
      iframe.removeEventListener('load', onLoad);
      this.loadingPayment = false;
    };

    iframe.addEventListener('load', onLoad);
    iframe.src = url;
  }

  closePaymentWindow(){
    $('#paymentDialog').modal('hide');
    this.loadingPayment = false;
  }
}
